<div class="filter-questions-container">
  <mat-radio-group fxLayout="column" [(ngModel)]="selectedFilter" (ngModelChange)="onFilterChange($event)">
    <mat-radio-button value="ungraded">{{isConsumerCurriculum ? 'Collapse All' : 'View Ungraded Content'}}</mat-radio-button>
    <mat-radio-button value="all">{{isConsumerCurriculum ? 'Expand All' : 'View All Content'}}</mat-radio-button>
  </mat-radio-group>
</div>
